(() => {
  const frames = Array.from(document.querySelectorAll('[data-miami-registration-frame]'));
  frames.forEach((frame) => {
    frame.addEventListener('load', () => {
      frame.contentWindow.postMessage(JSON.stringify({ parentUrl: window.location.href }), 'https://form-builder-en.pifyapp.com');
    });
  });
  window.addEventListener('message', (event) => {
    if (event.origin !== 'https://form-builder-en.pifyapp.com') return;
    const frame = frames.find((item) => item.contentWindow === event.source);
    if (!frame) return;
    let data = event.data;
    try { if (typeof data === 'string') data = JSON.parse(data); } catch { return; }
    if (data?.retsetHeight === true) {
      const headerHeight = document.querySelector('sticky-header')?.getBoundingClientRect().height || 100;
      frame.style.scrollMarginTop = `${Math.ceil(headerHeight) + 24}px`;
      frame.scrollIntoView({ block: 'start', behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
    }
    const height = Number(data?.height);
    if (Number.isFinite(height) && height >= 100 && height <= 2000) frame.style.height = `${Math.ceil(height)}px`;
  });
})();
